import { useEffect, useState } from "react";
import NocService from "./NocService";

const Dashboard = () => {
    const [deptCounts, setDeptCounts] = useState([]);
    const [approvedDeptCounts, setApprovedDeptCounts] = useState([]);
    const [rejectedDeptCounts, setRejectedDeptCounts] = useState([]);
    const [submittedCount, setSubmittedCount] = useState(0);
    const [approvedCount, setApprovedCount] = useState(0);
    const [rejectedCount, setRejectedCount] = useState(0);

    useEffect(() => {
        const fetchSubmittedData = () => {
            NocService.dashboardAction(1)
                .then((submittedResponse) => {
                    const submittedData = submittedResponse;
                    setSubmittedCount(submittedData.totalCount.cnt); // Total submitted count
                    setDeptCounts(submittedData.deptCount); // Department counts for submitted
                })
                .catch((error) => {
                    console.error("Error fetching submitted data", error);
                });
        };

        const fetchApprovedData = () => {
            NocService.dashboardAction(2)
                .then((approvedResponse) => {
                    const approvedData = approvedResponse;
                    setApprovedCount(approvedData.totalCount.cnt); // Total approved count
                    setApprovedDeptCounts(approvedData.deptCount); // Department counts for approved
                })
                .catch((error) => {
                    console.error("Error fetching approved data", error);
                });
        };

        const fetchRejectedData = () => {
            NocService.dashboardAction(4)
                .then((rejectedResponse) => {
                    const rejectedData = rejectedResponse;
                    setRejectedCount(rejectedData.totalCount.cnt); // Total rejected count
                    setRejectedDeptCounts(rejectedData.deptCount); // Department counts for rejected
                })
                .catch((error) => {
                    console.error("Error fetching rejected data", error);
                });
        };

        fetchSubmittedData();
        fetchApprovedData();
        fetchRejectedData();
    }, []);

    return (
        <main id="main" className="main">
            <section className="section">
                <div className="container-fluid">
                    {/* Page Heading */}
                    <div className="d-sm-flex align-items-center justify-content-between mb-4">
                        <h3 className="h3 mb-0 text-gray-800">NOC Application Dashboard</h3>
                    </div>

                    {/* Content Row */}
                    <div className="row">
                        <div className="col-xl-4 col-md-6 mb-4">
                            <div className="card border-left-success shadow h-100 py-2">
                                <div className="card-body">
                                    <a href="#" className="d-none d-sm-inline-block btn btn-sm btn-success shadow-sm w-100 rounded" style={{ fontSize: '1 rem', color: '#fff !important' }}>
                                        <i className="fa fa-paper-plane fa-sm text-white-50"></i> Submitted
                                    </a>
                                    <hr />
                                    <div className="row no-gutters align-items-center">
                                        <div className="col mr-2">
                                            <div className="text-xs font-weight-bold text-success text-uppercase mb-1">Submitted</div>
                                            <div className="h5 mb-0 font-weight-bold text-success">{submittedCount}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-xl-4 col-md-6 mb-4">
                            <div className="card border-left-primary shadow h-100 py-2">
                                <div className="card-body">
                                    <a href="#" className="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm w-100 rounded" style={{ fontSize: '1 rem', color: '#fff !important' }}>
                                        <i className="fas fa-thumbs-up fa-sm text-white-50"></i> Approved
                                    </a>
                                    <hr />
                                    <div className="row no-gutters align-items-center">
                                        <div className="col mr-2">
                                            <div className="text-xs font-weight-bold text-primary text-uppercase mb-1">Approved</div>
                                            <div className="h5 mb-0 font-weight-bold text-primary">{approvedCount}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-xl-4 col-md-6 mb-4">
                            <div className="card border-left-danger shadow h-100 py-2">
                                <div className="card-body">
                                    <a href="#" className="d-none d-sm-inline-block btn btn-sm btn-danger shadow-sm w-100 rounded" style={{ fontSize: '1 rem', color: '#fff !important' }}>
                                        <i className="fa fa-ban fa-sm text-white-50"></i> Rejected
                                    </a>
                                    <hr />
                                    <div className="row no-gutters align-items-center">
                                        <div className="col mr-2">
                                            <div className="text-xs font-weight-bold text-danger text-uppercase mb-1">Rejected</div>
                                            <div className="h5 mb-0 font-weight-bold text-danger">{rejectedCount}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Content Row for Department Counts */}
                    <div className="row">
                        {/* Submitted Department Counts */}
                        <div className="col-xl-4 col-md-6 mb-4">
                            <div className="card shadow mb-4">
                                <div className="card-header py-3">
                                    <h6 className="m-0 font-weight-bold text-success">Submitted Departments</h6>
                                </div>
                                <div className="card-body">
                                    <table className="table table-striped">
                                        <thead>
                                            <tr>
                                                <th scope="col">#</th>
                                                <th scope="col">Department</th>
                                                <th scope="col">Count</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {deptCounts.map((dept, index) => (
                                                <tr key={index}>
                                                    <th scope="row">{index + 1}</th>
                                                    <td>{dept.deptName}</td>
                                                    <td>{dept.cnt}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        {/* Approved Department Counts */}
                        <div className="col-xl-4 col-md-6 mb-4">
                            <div className="card shadow mb-4">
                                <div className="card-header py-3">
                                    <h6 className="m-0 font-weight-bold text-primary">Approved Departments</h6>
                                </div>
                                <div className="card-body">
                                    <table className="table table-striped">
                                        <thead>
                                            <tr>
                                                <th scope="col">#</th>
                                                <th scope="col">Department</th>
                                                <th scope="col">Count</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {approvedDeptCounts.map((dept, index) => (
                                                <tr key={index}>
                                                    <th scope="row">{index + 1}</th>
                                                    <td>{dept.deptName}</td>
                                                    <td>{dept.cnt}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        {/* Rejected Department Counts */}
                        <div className="col-xl-4 col-md-6 mb-4">
                            <div className="card shadow mb-4">
                                <div className="card-header py-3">
                                    <h6 className="m-0 font-weight-bold text-danger">Rejected Departments</h6>
                                </div>
                                <div className="card-body">
                                    <table className="table table-striped">
                                        <thead>
                                            <tr>
                                                <th scope="col">#</th>
                                                <th scope="col">Department</th>
                                                <th scope="col">Count</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {rejectedDeptCounts.map((dept, index) => (
                                                <tr key={index}>
                                                    <th scope="row">{index + 1}</th>
                                                    <td>{dept.deptName}</td>
                                                    <td>{dept.cnt}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
};

export default Dashboard;
